import { useEffect, useState } from "react";
import { fetchCostCenterOfficeMappings, downloadMappingsExcel } from "../Api/ViewCostCenterOfficeMapping";
import { Container, Table, Button } from "react-bootstrap";

import { toast } from "react-toastify";
import moment from "moment";

const ViewCostCenterOfficeMapping = () => {
  const [mappings, setMappings] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    const loadMappings = async () => {
      try {
        const data = await fetchCostCenterOfficeMappings();
        setMappings(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Cost Center Office Mappings`);
      }
    };

    loadMappings();
  }, []);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await downloadMappingsExcel();
      
      if (!response.data) {
        throw new Error("No data received from server");
      }
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'CostCenterOfficeMappings.xlsx');
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      }, 100);
      
      toast.success("Mappings data download started!");
    } catch (error) {
      console.error("Download error:", error);
      toast.error(`🦄 Download failed: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="list-container">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <span className="list-title">View Cost Center Office Mappings</span>
              <Button className="generate-btn"
                variant="primary" 
                onClick={handleDownload}
                disabled={isDownloading || mappings.length === 0}
              >
                {isDownloading ? 'Downloading...' : 'Download Data'}
              </Button>
            </div>

            {mappings.length > 0 ? (
              <div className="table-wrapper">
                <div className="table-scroll-container">
                  <Table bordered hover className="data-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Mapping ID</th>
                        <th>Cost Center</th>
                        <th>Office Code</th>
                        <th>Created At</th>
                        <th>Created By</th>
                      </tr>
                    </thead>
                    <tbody>
                      {mappings.map((mapping, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{mapping.mappingId}</td>
                          <td>{mapping.costCenter}</td>
                          <td>{mapping.officeCode}</td>
                          <td>{moment(mapping.createdAt).format('L')} at {moment(mapping.createdAt).format('LTS')}</td>
                          <td>{mapping.createdBy}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            ) : (
              <p className="no-data">No mappings found.</p>
            )}
          </Container>
        </div>
      
    </>
  );
};

export default ViewCostCenterOfficeMapping;